import React from 'react'
import { Footer } from '../components/footer';

const AboutusPage = () => {
    return (
        <>
        <div className="mainContent">
            <div className="pageContent py-5">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-12">
                            <div className="aboutusBanner">
                                <div className='row align-items-center'>
                                    <div className="col-lg-6 col-md-5">
                                        <div className='text-center mb-4 mb-md-0'>
                                            <img src={require('../assets/images/aboutsCoin.gif')} alt='aboutusCoin' className='img-fluid aboutleftImg' />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-7">
                                        <div className="aboutusBannerCnt">
                                            <h2>About Us</h2>
                                            <p>When an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className='col-lg-12'>
                        <div className="row align-items-centers">
                            <div className="col-lg-6">
                                <div>
                                    <div className="aboutcntTxt">
                                        <h3>Our Mission</h3>
                                        <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className='aboutImg'>
                                    <img src={require('../assets/images/aboutImg01.png')} alt='aboutusImg' className='img-fluid img1' />
                                    <img src={require('../assets/images/aboutImg01.png')} alt='aboutusImg' className='img-fluid img2' />
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-centers">
                        <div className="col-lg-6">
                                <div className='aboutImg'>
                                    <img src={require('../assets/images/aboutImg02.png')} alt='aboutusImg' className='img-fluid img1 rightImg' />
                                    <img src={require('../assets/images/aboutImg02.png')} alt='aboutusImg' className='img-fluid img2 rightImg' />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div>
                                    <div className="aboutcntTxt">
                                        <h3>Our Vision</h3>
                                        <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </>
    )
}

export default AboutusPage;